import styled from "styled-components";
import { BodySmall } from "../../../components/typography/styled";

export const Container = styled.div`
  padding: 10px 30px 10px 20px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: clip;

  @media (max-width: 768px) {
    padding: 10px 16px 32px;
  }
`
export const Date = styled(BodySmall)`
  color:${({theme}) => theme.palette[600]};
  margin-right:6px;
`

export const DateWrapper = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
`
export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;

  > :first-child {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  > img {
    flex: 0 0 60px;
  }
`

export const DivMessage = styled.div`
  color:${({theme}) => theme.base.black};
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;

  p {
    overflow-wrap: anywhere;
  }

  img,
  video,
  iframe {
    max-width: 100% !important;
    height: auto;
  }

  pre,
  table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
  }
`
